module.exports = __webpack_public_path__ + "img/cabecera-mascara.ca9d9df6.jpg";